import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const BUYERS = [{
  name: 'Alejandro M.',
  city: 'Madrid'
}, {
  name: 'Carmen R.',
  city: 'Barcelona'
}, {
  name: 'Sofía L.',
  city: 'Valencia'
}, {
  name: 'Pablo G.',
  city: 'Sevilla'
}, {
  name: 'Natalia F.',
  city: 'Bilbao'
}, {
  name: 'Marcos V.',
  city: 'Zaragoza'
}, {
  name: 'Laura D.',
  city: 'Málaga'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(BUYERS[0]);
  useEffect(() => {
    const showInterval = setInterval(() => {
      const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    }, 25000);
    return () => clearInterval(showInterval);
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 max-w-sm w-full pointer-events-none" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
    transition: 'opacity 0.3s ease, transform 0.3s ease',
    willChange: 'opacity, transform',
    contain: 'layout style'
  }} data-id="element-6">
      <div className="bg-white text-brand-black p-4 rounded-lg shadow-2xl border-l-4 border-brand-gold flex items-start space-x-3 pointer-events-auto" data-id="element-7">
        <CheckCircle2 className="text-brand-gold w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-8" />
        <div data-id="element-9">
          <p className="text-sm font-bold" data-id="element-10">
            {currentBuyer.name} de {currentBuyer.city}
          </p>
          <p className="text-xs text-gray-600 mt-1" data-id="element-11">
            Acaba de comprar el Megapack SIN LÍMITES
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-12">Hace unos minutos</p>
        </div>
      </div>
    </div>;
}